import { Box, TextField } from "@mui/material";
import InputMask from "react-input-mask";
import { useTranslation } from "react-i18next";
import CoordinateSelector from "@/components/general/CoordinateSelector";
import fetchCep from "@/hooks/useCep";
import ComercialInterfaceHeader from "@/components/comercial/ComercialInterfaceHeader";
import {sharedStyles} from "@/styles/shared";

export const AddressDataForm = ({ cep, setCep, refs, coordinates, setCoordinates }: any) => {
    const { t } = useTranslation();

    const foundedCepAddress = fetchCep(cep, refs.street, refs.district, refs.city, refs.state, true);

    const isFieldDisabled = foundedCepAddress !== null && refs.street?.current?.value !== "";

    return (
        <>
            <ComercialInterfaceHeader title={t("storePage.management.add.geoTitle")} />
            <Box sx={sharedStyles.verticalContent}>
                <InputMask mask="99999-999" maskChar="_" value={cep} onChange={(e) => setCep(e.target.value)}>
                    <TextField size="small" label={t("storePage.management.add.form.zip")} fullWidth />
                </InputMask>

                <Box sx={{ ...sharedStyles.verticalContent, flexDirection: "row" }}>
                    <TextField
                        size="small"
                        label={t("storePage.management.add.form.street")}
                        inputRef={refs.street}
                        sx={{ width: "75%" }}
                        InputLabelProps={{ shrink: true }}
                        disabled={isFieldDisabled}
                    />
                    <TextField
                        size="small"
                        label={t("storePage.management.add.form.number")}
                        inputRef={refs.number}
                        sx={{ width: "25%" }}
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>

                <TextField
                    size="small"
                    label={t("storePage.management.add.form.district")}
                    fullWidth
                    inputRef={refs.district}
                    InputLabelProps={{ shrink: true }}
                    disabled={isFieldDisabled}
                />

                <Box sx={{ ...sharedStyles.verticalContent, flexDirection: "row" }}>
                    <TextField
                        size="small"
                        label={t("storePage.management.add.form.city")}
                        fullWidth
                        inputRef={refs.city}
                        InputLabelProps={{ shrink: true }}
                        disabled={isFieldDisabled}
                    />
                    <TextField
                        size="small"
                        label={t("storePage.management.add.form.state")}
                        fullWidth
                        inputRef={refs.state}
                        InputLabelProps={{ shrink: true }}
                        disabled={isFieldDisabled}
                    />
                </Box>

                {foundedCepAddress && (
                    <Box sx={{ alignSelf: "flex-end", marginTop: 3 }}>
                        <CoordinateSelector coordinates={coordinates} setCoordinates={setCoordinates} brazilianAddress={foundedCepAddress} />
                    </Box>
                )}
            </Box>
        </>
    );
};